import { Box, Button, Divider, Flex, Text } from "@chakra-ui/react";

export const WriteLeftDotLine = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Flex data-testid={"write-left-dot-line"}>
      <Box>
        <Divider
          mx={4}
          orientation="vertical"
          borderColor="gray.200"
          borderStyle="dotted"
          borderLeftWidth={2}
          borderRightWidth={0}
          borderTopWidth={0}
          borderBottomWidth={0}
        />
      </Box>
      {children}
    </Flex>
  );
};
